import { SidebarProvider, SidebarTrigger } from "../Components/ui/sidebar.tsx";
import { AppSidebar } from "../Components/app-sidebar.tsx";
import { Outlet } from "react-router-dom";
//import { Toaster } from "@/Components/ui/toaster";
import { CommandMenu } from "@/Components/CommandMenu.tsx";
import TaskBar from "@/Components/ui/taskBar.tsx";
import { Toaster } from "@/Components/ui/toaster.tsx";
import { useResponsiveZoom } from "@/hooks/use-responsive-zoom";
import React from "react";

function PageLayout() {
    const zoomLevel = useResponsiveZoom();
    
    // Calculate adjusted sidebar width based on zoom level
    const sidebarWidth = React.useMemo(() => {
        const baseWidth = 16; // 16rem
        return `${baseWidth * zoomLevel}rem`;
    }, [zoomLevel]);
    
    return (
        <SidebarProvider 
            style={{ "--sidebar-width": sidebarWidth } as React.CSSProperties}
            zoomLevel={zoomLevel}
        >
            <Toaster />
            <AppSidebar />
            <main className="flex grow flex-col">
                <SidebarTrigger className="-ml-1" />
                <Outlet />
                <CommandMenu />
                <TaskBar />
            </main>
        </SidebarProvider>
    );
}

export default PageLayout;